// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2p_fk","right":"styles_right__3pzk6"};